import React from 'react';

function XClose(props) {
  return (
    <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2.98 2.11a.625.625 0 0 0-.797.956l8.933 8.933-8.933 8.933-.072.087a.625.625 0 0 0 .956.797L12 12.883l8.933 8.933.087.072a.625.625 0 0 0 .797-.956L12.884 12l8.933-8.933.072-.087a.625.625 0 0 0-.956-.797L12 11.115 3.067 2.182 2.98 2.11Z"
        fillRule="evenodd"
      />
      <mask height="21" id="a" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }} width="20" x="2" y="1">
        <path
          clipRule="evenodd"
          d="M2.98 2.11a.625.625 0 0 0-.797.956l8.933 8.933-8.933 8.933-.072.087a.625.625 0 0 0 .956.797L12 12.883l8.933 8.933.087.072a.625.625 0 0 0 .797-.956L12.884 12l8.933-8.933.072-.087a.625.625 0 0 0-.956-.797L12 11.115 3.067 2.182 2.98 2.11Z"
          fillRule="evenodd"
        />
      </mask>
    </svg>
  );
}

export default XClose;
